import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>Why Choose</span> TekRevol as Your React Native Mobile App
              Development Company?
            </h2>
          </Col>
        </Row>
        <Row className="h-100 choose_padd">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <p>
              Choosing TekRevol's React Native development services means more
              than hiring a team of dedicated professionals; it's partnering
              with industry experts devoted to translating ideas into
              full-fledged projects.
            </p>
            <p>
              We start by understanding your requirements in detail, utilizing
              our technical expertise to create functional and user-friendly
              applications.
            </p>
            <p>
              Prioritize a faultless user experience, robust functionalities,
              and timely delivery within 2 to 3 months. Our commitment extends
              beyond development and deployment.
            </p>
            <p>
              We are dedicated to complete maintenance and updates, permitting
              you to concentrate on your business – fostering it to grow and
              satisfy all your customers' needs.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Schedule A Free Consultation Session
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
            <StaticImage
              src="../../images/services-usa/react-native/Why-Choose.webp"
              alt="tekrevol_react"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={910}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whychooseusa;
